export enum Weekdays {
  Monday = 1 << 0,
  Tuesday = 1 << 1,
  Wednesday = 1 << 2,
  Thursday = 1 << 3,
  Friday = 1 << 4,
  Saturday = 1 << 5,
  Sunday = 1 << 6
}

export const WeekdayLabels: { [key: number]: string } = {
  [Weekdays.Monday]: "Montag",
  [Weekdays.Tuesday]: "Dienstag",
  [Weekdays.Wednesday]: "Mittwoch",
  [Weekdays.Thursday]: "Donnerstag",
  [Weekdays.Friday]: "Freitag",
  [Weekdays.Saturday]: "Samstag",
  [Weekdays.Sunday]: "Sonntag"
};


